<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<p class="bk"><a class="page" id="page.i"></a><a class="page" id="page.ii"></a><a class="page" id="page.iii"></a>The Book of</p>
<p class="bk1">NUMBERS</p>
<hr/>
<p class="bkau">Timothy R. Ashley</p>
<p class="bkpub">W<span class="sm">ILLIAM</span> B<span class="sm">.</span> E<span class="sm">ERDMANS</span> P<span class="sm">UBLISHING</span> C<span class="sm">OMPANY</span></p>
<p class="bkpub1">G<span class="sm">RAND</span> R<span class="sm">APIDS,</span> M<span class="sm">ICHIGAN</span> <span class="sm">/</span> C<span class="sm">AMBRIDGE,</span> U<span class="sm">.</span>K<span class="sm">.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-nicot04nu-0002.vue?44045b3c